import { AcLockObject } from '@utils/ac-lock-object';

const WP_API = process.env.REACT_APP_API_URL_WP;

const FAQS = '/faqs';
const PAGES = '/pages';
const PUBLICATIONS = '/publications';
const SEARCH = '/search';
const ATTACHMENTS = '/attachments';
const THEMES = '/themes';
const MENUS = '/menu';
const CATEGORIES = '/categories';

// OpenCatalogi publications API: base-URL (API_URL_COMMONGROUND) bevat al
// {host}/apps/opencatalogi/api; paden zijn relatief aan de catalogus.
const API_CONDUCTION = '';

export const ENDPOINTS = AcLockObject({
  PUBLICATIONS: {
    SEARCH: `${API_CONDUCTION}${PUBLICATIONS}`, // GET
    SINGLE: (_id) => `${API_CONDUCTION}${PUBLICATIONS}/${_id}`, // GET
    ATTACHMENTS: (_id) => `${API_CONDUCTION}${PUBLICATIONS}/${_id}${ATTACHMENTS}`, // GET
  },
  THEMES: {
    INDEX: `${API_CONDUCTION}${THEMES}`,
  },
  FAQS: {
    INDEX: `${WP_API}/public${FAQS}`, // GET
    SHOW: (_id) => `${WP_API}/public${FAQS}/${_id}`, // GET
  },
  PAGES: {
    INDEX: `${WP_API}/public${PAGES}`, // GET
    SHOW: (_slug) => `${WP_API}/public${PAGES}/${_slug}`, // GET
  },
  MENUS: {
    INDEX: `${WP_API}/public${MENUS}`, // GET
  },
  CATEGORIES: {
    INDEX: `${WP_API}/public${CATEGORIES}`, // GET
  },
});

export default ENDPOINTS;
